/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { WorkspaceChainFragmentDoc, WorkspaceChainPrimaryDeploymentFragmentDoc } from './fragments.generated';
import { DeploymentCountByStatusFragmentDoc } from '../../../Workspace/__generated__/fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkspaceChainsQueryVariables = Types.Exact<{
  teamId?: Types.InputMaybe<Types.Scalars['String']>;
  all?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type WorkspaceChainsQuery = { __typename?: 'QueryPrediction', chains: Array<{ __typename?: 'ChainType', id: string, name: string | null | undefined, created: any, modified: any, lastActivity: string | null | undefined, primaryDeployment: { __typename?: 'ChainDeploymentType', id: string, status: Types.ChainDeploymentStatus | null | undefined, created: any, isPrimary: boolean } | null | undefined, deploymentCountByStatus: Array<{ __typename?: 'ChainDeploymentByStatusCount', status: Types.ChainDeploymentStatus | null | undefined, count: number | null | undefined } | null | undefined> | null | undefined, team: { __typename?: 'TeamType', id: string, name: string, icon: string | null | undefined } | null | undefined } | null | undefined> | null | undefined };


export const WorkspaceChainsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceChains"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chains"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkspaceChainFragment"}}]}}]}},...WorkspaceChainFragmentDoc.definitions,...WorkspaceChainPrimaryDeploymentFragmentDoc.definitions,...DeploymentCountByStatusFragmentDoc.definitions]} as unknown as DocumentNode<WorkspaceChainsQuery, WorkspaceChainsQueryVariables>;
export const namedOperations = {
  Query: {
    WorkspaceChains: 'WorkspaceChains'
  }
}

/**
 * __useWorkspaceChainsQuery__
 *
 * To run a query within a React component, call `useWorkspaceChainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceChainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceChainsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useWorkspaceChainsQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceChainsQuery, WorkspaceChainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceChainsQuery, WorkspaceChainsQueryVariables>(WorkspaceChainsDocument, options);
      }
export function useWorkspaceChainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceChainsQuery, WorkspaceChainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceChainsQuery, WorkspaceChainsQueryVariables>(WorkspaceChainsDocument, options);
        }
export type WorkspaceChainsQueryHookResult = ReturnType<typeof useWorkspaceChainsQuery>;
export type WorkspaceChainsLazyQueryHookResult = ReturnType<typeof useWorkspaceChainsLazyQuery>;
export type WorkspaceChainsQueryResult = Apollo.QueryResult<WorkspaceChainsQuery, WorkspaceChainsQueryVariables>;
export function refetchWorkspaceChainsQuery(variables?: WorkspaceChainsQueryVariables) {
      return { query: WorkspaceChainsDocument, variables: variables }
    }